var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.974 11.6541L30 4.66675V32.6668H39.3333V17.3274C39.3333 15.1974 38.484 13.1554 36.974 11.6541Z",
    fill: "#FFB782"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11743 27.5647L0.845454 13.878C0.316125 12.504 1.00082 10.9607 2.37544 10.4313L27.2601 0.846003C28.6341 0.316674 30.1774 1.00136 30.7068 2.37599L35.9787 16.0627C36.5081 17.4366 35.8234 18.98 34.4488 19.5093L9.56476 29.0947C8.19006 29.624 6.64741 28.9386 6.11743 27.5647Z",
    fill: "#DE4C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6069 7.3067L2.76953 18.872L4.75622 24.0294L34.5949 12.4694L32.6069 7.3067Z",
    fill: "#7A4930"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 18V3.33328C0.666504 1.86064 1.86051 0.666626 3.33316 0.666626H29.9999C31.4725 0.666626 32.6665 1.86064 32.6665 3.33328V17.9999C32.6665 19.4726 31.4725 20.6666 29.9999 20.6666H3.33316C1.86051 20.6667 0.666504 19.4726 0.666504 18Z",
    fill: "#4398D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 0.666626H27.1665L7.1665 20.6667H29.9998C31.4725 20.6667 32.6665 19.4726 32.6665 18V3.33328C32.6665 1.86064 31.4725 0.666626 29.9998 0.666626Z",
    fill: "#3E8CC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00015 11.3334H3.3335V12.6667H6.00015V11.3334Z",
    fill: "#5EB3D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00015 15.3334H3.3335V16.6667H6.00015V15.3334Z",
    fill: "#5EB3D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 15.3334H15.3335V16.6667H18.0002V15.3334Z",
    fill: "#5EB3D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 11.3334H7.3335V12.6667H10.0002V11.3334Z",
    fill: "#5EB3D1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 11.3334H11.3335V12.6667H14.0002V11.3334Z",
    fill: "#5EB3D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 11.3334H15.3335V12.6667H18.0002V11.3334Z",
    fill: "#5EB3D1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 3.33331H28V5.33332H29.3334V3.33331Z",
    fill: "#5EB3D1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6669 3.33331H25.3335V5.33332H26.6669V3.33331Z",
    fill: "#5EB3D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 3.33331H22.6665V5.33332H23.9999V3.33331Z",
    fill: "#5EB3D1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 3.33331H20V5.33332H21.3334V3.33331Z",
    fill: "#5EB3D1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3335 32.6667H27.3335V39.3334H39.3335V32.6667Z",
    fill: "#88B337"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3768 12.71C24.2461 11.5833 22.4162 11.5866 21.2895 12.7173C20.2001 13.8107 20.1621 15.5674 21.2035 16.7067L26.6668 22.6667C25.0248 25.5406 25.0948 29.0847 26.8488 31.8913L27.3335 32.6667H36.0002V23.3333L25.3768 12.71Z",
    fill: "#FFB782"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6669 34.6667H29.3335V36H30.6669V34.6667Z",
    fill: "#6B962A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 7.60003V4.40004C3.3335 3.81068 3.8108 3.33337 4.40016 3.33337H7.60015C8.18951 3.33337 8.66681 3.81068 8.66681 4.40004V7.60003C8.66681 8.18939 8.18951 8.66669 7.60015 8.66669H4.40023C3.81086 8.66669 3.3335 8.18932 3.3335 7.60003Z",
    fill: "#FDB62F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33351 5.33331H3.3335V6.66667H5.33351V5.33331Z",
    fill: "#FD7B2F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66651 5.33331H6.6665V6.66667H8.66651V5.33331Z",
    fill: "#FD7B2F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3331 23.3334C35.1564 23.3334 34.9864 23.2634 34.8617 23.138L32.1951 20.4714C31.9391 20.2067 31.9464 19.7847 32.2117 19.5287C32.4704 19.2794 32.8798 19.2794 33.1377 19.5287L35.8044 22.1954C36.0644 22.456 36.0644 22.878 35.8044 23.138C35.6791 23.2634 35.5098 23.3334 35.3331 23.3334Z",
    fill: "#F2A46F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 7.06269V3.33331C33.3314 1.49332 31.84 0.00196826 30 0H3.33331C1.49332 0.00196826 0.00196826 1.49332 0 3.33331V18C0.00531429 19.7026 1.29531 21.1259 2.98932 21.2986L5.4953 27.804C6.15729 29.522 8.08599 30.378 9.80395 29.716L25.4533 23.688C24.3719 26.5127 24.6793 29.6807 26.284 32.2447L26.6666 32.8573V39.3334C26.6666 39.7013 26.9653 40 27.3333 40H39.3333C39.7013 40 39.9999 39.7013 39.9999 39.3334V17.3273C39.994 15.022 39.0759 12.8133 37.4459 11.1826L33.3334 7.06269ZM33.3334 11.0493L35.3568 16.302C35.7534 17.3327 35.2394 18.49 34.2087 18.8867L33.0521 19.3333C33.2367 18.9133 33.3327 18.4593 33.3334 18V11.0493ZM1.33336 18V3.33331C1.33336 2.22866 2.22872 1.3333 3.33337 1.3333H30.0001C31.1047 1.3333 32.0001 2.22866 32.0001 3.33331V7.57063H31.9941L32.0001 7.58598V18C31.9948 18.116 31.9801 18.232 31.9548 18.3454L25.8481 12.238C24.4428 10.8654 22.1914 10.8913 20.8188 12.2967C19.5094 13.6367 19.4641 15.762 20.7148 17.1567L23.3181 20H3.33331C2.22866 20 1.33336 19.1047 1.33336 18ZM9.87401 21.3333L5.13334 23.1587L4.43199 21.3333H9.87401ZM9.32468 28.472C8.29403 28.8693 7.1367 28.3553 6.73937 27.3246L5.61471 24.3999L13.5727 21.3333V21.3293H24.54L25.4067 22.274L9.32468 28.472ZM38.6667 38.6667H28V33.3334H38.6667V38.6667ZM38.6667 32H27.7033L27.414 31.538C25.7887 28.9407 25.724 25.6594 27.2453 23C27.3893 22.748 27.354 22.4327 27.158 22.2186L21.6946 16.2586C20.8667 15.352 20.93 13.9459 21.8366 13.1173C22.7133 12.3166 24.0646 12.3459 24.9053 13.184L35.5286 23.8047L36.4712 22.862L34.0046 20.3953L34.6886 20.1286C36.4052 19.4666 37.2606 17.5393 36.5999 15.822L34.3432 9.96259L36.5033 12.1266C37.8833 13.506 38.6613 15.3759 38.6666 17.3273L38.6667 32Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60029 9.33336C8.55765 9.33336 9.3336 8.55734 9.3336 7.60005V4.40006C9.3336 3.4427 8.55759 2.66675 7.60029 2.66675H4.4003C3.44294 2.66675 2.66699 3.44277 2.66699 4.40006V7.60005C2.66699 8.55741 3.44301 9.33336 4.4003 9.33336H7.60029ZM4.00029 7.60005V6.6667H5.33358V5.33334H4.00029V4.40006C4.00029 4.17942 4.1796 4.00004 4.4003 4.00004H7.60029C7.82093 4.00004 8.00031 4.17935 8.00031 4.40006V5.33334H6.66695V6.6667H8.00031V7.60005C8.00031 7.82069 7.821 8.00006 7.60029 8.00006H4.4003C4.1796 8 4.00029 7.82069 4.00029 7.60005Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00015 11.3334H3.3335V12.6667H6.00015V11.3334Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00015 15.3334H3.3335V16.6667H6.00015V15.3334Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 15.3334H15.3335V16.6667H18.0002V15.3334Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 11.3334H7.3335V12.6667H10.0002V11.3334Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 11.3334H11.3335V12.6667H14.0002V11.3334Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 11.3334H15.3335V12.6667H18.0002V11.3334Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 3.33331H28V5.33332H29.3334V3.33331Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6669 3.33331H25.3335V5.33332H26.6669V3.33331Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 3.33331H22.6665V5.33332H23.9999V3.33331Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 3.33331H20V5.33332H21.3334V3.33331Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6669 34.6667H29.3335V36H30.6669V34.6667Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.d4353c277c956a8cb07df79748560c6c.svg";
export { ForwardRef as ReactComponent };